import { useState } from "react";
import { Button, Checkbox, Flex, Image, Typography } from "antd";

import StyledModal from "./style";

import { TERMS_LINK } from "../../utils/constant";

import Close from "../../icon/Close";
import PennyLogo from "../SectionAskAdvice/images/penny_logo_2.svg";

const { Text, Link } = Typography;

const ModalPennyTerms = ({ onCancel, onConfirm, open }) => {
  const [acceptedPennyTerms, setAcceptedPennyTerms] = useState(false);

  const handleCheckboxChange = e => {
    setAcceptedPennyTerms(e.target.checked);
  };

  return (
    <StyledModal
      centered
      closeIcon={<Close />}
      footer={
        <Flex justify="start">
          <Button
            type="secondary"
            shape="round"
            style={{ width: 193, fontSize: 18 }}
            disabled={!acceptedPennyTerms}
            onClick={onConfirm}
          >
            Start Conversation
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title={<Image preview={false} src={PennyLogo} />}
      width={604}
      zIndex={1001}
    >
      <h4 className="title">
        Welcome to Penny, OnTrajectory’s AI coach powered by ChatGPT.
      </h4>
      <p className="description">
        Before you opt in, please read and{" "}
        <Link href={TERMS_LINK} target="_blank">
          accept our terms and conditions.
        </Link>
      </p>
      <p className="description">
        Please note that Penny is not an investment advisor and does not provide
        investment advice. It may produce inaccurate or incomplete responses at
        times.
      </p>
      <p className="description">
        When interacting with Penny, please do not provide any personally
        identifiable information such as your Social Security number, or your
        banking or brokerage account number.
      </p>
      <p className="description">
        <Checkbox checked={acceptedPennyTerms} onChange={handleCheckboxChange}>
          <Text style={{ marginLeft: 7 }}>
            I agree to the{" "}
            <Link href={TERMS_LINK} target="_blank">
              terms & conditions.
            </Link>
          </Text>
        </Checkbox>
      </p>
    </StyledModal>
  );
};

export default ModalPennyTerms;
